module.exports = __webpack_public_path__ + "img/arrow-up-right-circle-fill.3523cbbb.svg";